import LoginHeader from '@/features/auth/components/LoginHeader';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoginFooter } from './login-footer';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <LoginHeader />

      <main className="flex items-center justify-center px-4 py-8 flex-grow">
        <Suspense fallback={<div />}>
          <Outlet />
        </Suspense>
      </main>

      <LoginFooter />
    </div>
  );
}
